import { render, staticRenderFns } from "./refrigeratory.vue?vue&type=template&id=63656924&scoped=true&"
import script from "./refrigeratory.vue?vue&type=script&lang=js&"
export * from "./refrigeratory.vue?vue&type=script&lang=js&"
import style0 from "./refrigeratory.vue?vue&type=style&index=0&id=63656924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63656924",
  null
  
)

export default component.exports